import { axiosPut, del, get, post } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  createRoleFailed,
  createRoleSuccess,
  deleteRoleFailed,
  deleteRoleSuccess,
  getAdminRolesFailed,
  getAdminRolesSuccess,
  getRoleFailed,
  getRoleSuccess,
  hideAdminRoleModal,
  hideDeleteRoleModal,
  updateRoleFailed,
  updateRoleSuccess,
} from "./actions"
import * as url from "helpers/url_helper"
import {
  CREATE_ROLE,
  DELETE_ROLE,
  GET_ADMIN_ROLES,
  GET_ROLE,
  UPDATE_ROLE,
} from "./actionTypes"

function* getAdminRoles({ payload: params }) {
  try {
    const response = yield get(url.GET_ADMIN_ROLES)
    yield put(getAdminRolesSuccess(response))
  } catch (error) {
    yield put(getAdminRolesFailed(error))
    showToast("error", error, "Error")
  }
}

function* getRole({ payload: params }) {
  try {
    const response = yield get(`${url.GET_ADMIN_ROLES}/${params?.id}`)
    yield put(getRoleSuccess(response))
  } catch (error) {
    yield put(getRoleFailed(error))
    showToast("error", error, "Error")
  }
}

function* createRole({ payload: params }) {
  try {
    const response = yield post(url.GET_ADMIN_ROLES, params)
    yield put(createRoleSuccess(response))
    yield put(hideAdminRoleModal())
    showToast("success", "Role created!", "Success")
  } catch (error) {
    yield put(createRoleFailed(error))
    yield put(hideAdminRoleModal())
    showToast("error", error, "Error")
  }
}

function* updateRole({ payload: params }) {
  try {
    const response = yield axiosPut(
      `${url.GET_ADMIN_ROLES}/${params?.id}`,
      params
    )
    yield put(updateRoleSuccess(response))
    yield put(hideAdminRoleModal())
    showToast("success", "Role updated!", "Success")
  } catch (error) {
    yield put(updateRoleFailed(error))
    yield put(hideAdminRoleModal())
    showToast("error", error, "Error")
  }
}

function* deleteRole({ payload: params }) {
  try {
    yield del(`${url.GET_ADMIN_ROLES}/${params?.id}`)
    yield put(deleteRoleSuccess(params?.id))
    yield put(hideDeleteRoleModal())
    showToast("success", "Role deleted!", "Success")
  } catch (error) {
    yield put(deleteRoleFailed(error))
    yield put(hideDeleteRoleModal())
    showToast("error", error, "Error")
  }
}

function* rolesSaga() {
  yield takeEvery(GET_ADMIN_ROLES, getAdminRoles)
  yield takeEvery(GET_ROLE, getRole)
  yield takeEvery(CREATE_ROLE, createRole)
  yield takeEvery(UPDATE_ROLE, updateRole)
  yield takeEvery(DELETE_ROLE, deleteRole)
}

export default rolesSaga
